import { render, staticRenderFns } from "./classroomQuery.vue?vue&type=template&id=510eb68e&scoped=true&"
import script from "./classroomQuery.vue?vue&type=script&lang=js&"
export * from "./classroomQuery.vue?vue&type=script&lang=js&"
import style0 from "./classroomQuery.vue?vue&type=style&index=0&id=510eb68e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510eb68e",
  null
  
)

export default component.exports